import { Formik } from "formik";
import PropTypes from "prop-types";
import ModalConfirm from "components/modals/modal-confirm";
import Modal from "components/modals/modal";
import FilterTextInput from "apps/filters/components/filter-text-input";
import { ListSchema } from "apps/lists/components/schema/list-schema";
import CharacterCounter from "apps/interactions/components/character-counter";

const NewListModal = ({remove, onUnmount, onSubmit }) => {
  const handleSubmit = (values) => {
    onSubmit(values.list_name);
  };

  return (
    <Formik
      initialValues={{ list_name: "" }}
      validationSchema={ListSchema}
      onSubmit={handleSubmit}
    >
      {({ handleChange, handleSubmit, values, errors, touched }) => (
        <Modal width={400} keepOpen={true} remove={remove} onUnmount={onUnmount}>
          <ModalConfirm
            type="success"
            header="Add to New List"
            buttonLabel="Add"
            hasMargin={true}
            hide_close_icon={true}
            onSubmit={handleSubmit}
            disableButton={!values.list_name || !!errors.list_name}
          >
            <FilterTextInput
              className="add-new-list--input"
              placeholder="New list name..."
              value={values.list_name}
              onChange={handleChange("list_name")}
            />
            <CharacterCounter limit={120} count={(values.list_name || "").length} />
          </ModalConfirm>
        </Modal>
      )}
    </Formik>
  );
};

NewListModal.propTypes = {
  remove: PropTypes.func,
  onUnmount: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
};

export default NewListModal;
